import styled from 'styled-components';

export const GridWrapper = styled.div`
    height: calc(100% - 44px);
    min-height: 300px;
    padding-top: 12px;
`